<template>
    <v-snackbar
        v-model="active"
        :timeout="showClose ? -1 : timeout"
        :color="color"
        location="top center"
        :multi-line="multiLine"
        :vertical="vertical"
        :class="classes"
        role="alert"
        style="pointer-events: auto"
        @click="dismiss"
    >
        <v-icon v-if="!!icon" :color="iconColor" start class="vts__icon">
            {{ icon }}
        </v-icon>
        <div :class="{'vts__message--padded': showClose && !closeText}" class="vts__message">
            <div v-html="message" />
            <slot />
        </div>
        <template v-slot:actions>
            <v-btn
                v-if="showClose"
                :icon="!closeText"
                :variant="!!closeText ? 'text' : null"
                :class="{'vts__close--icon': !closeText}"
                :color="closeColor"
                class="vts__close"
                @click="close"
            >
                <v-icon v-if="!closeText">{{ closeIcon }}</v-icon>
                <span v-else>{{ closeText }}</span>
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'

    // TODO [P3] Need to check behavior with rare options
    @Component
    export class Toast extends Vue {
        @Prop({default: 'center', type: String}) x
        @Prop({default: 'top', type: String}) y
        @Prop({default: 'info', type: String}) color
        @Prop({default: '', type: String}) icon
        @Prop({default: '', type: String}) iconColor
        @Prop({default: '', type: [String, Object, Array]}) classes
        @Prop({default: '', type: String}) message
        @Prop({default: 5000, type: Number}) timeout
        @Prop({default: true, type: Boolean}) dismissable
        @Prop({default: false, type: Boolean}) multiLine
        @Prop({default: false, type: Boolean}) vertical
        @Prop({default: false, type: Boolean}) showClose
        @Prop({default: '', type: String}) closeText
        @Prop({default: 'mdi-close', type: String}) closeIcon
        @Prop({default: '', type: String}) closeColor
        @Prop({default: () => () => {}}) destroy
        @Prop() closeAction?: Function

        active = false

        @Watch('active')
        onChangeActive(active: boolean) {
            if (!active) {
                this.destroy()
            }
        }

        mounted() {
            this.active = true
        }

        async close() {
            this.active = false
            if (this.closeAction) this.closeAction()
        }

        dismiss() {
            if (this.dismissable && !this.showClose) this.close()
        }
    }

    export default Toast
</script>
